import NavbarView from '../../views/navbarView/NavbarView';
import AddMethodView from './views/AddMethodView';
import { AddMethodDataProvider } from './context/AddMethodContext';
import useCsideScript from '../../hooks/useCsideScript';

export function AddMethod() {
    useCsideScript();

    return (
        <>
            <NavbarView />
            <AddMethodDataProvider>
                <AddMethodView />
            </AddMethodDataProvider>
        </>
    );
}
